<template>
  <div class="flex flex-col items-center justify-center disclaimer-dark">
    <v-photo-swipe fade-transition class="flex items-center justify-center w-full h-full gallery">
      <swiper
        :slides-per-view="5"
        :space-between="0"
        free-mode
        watch-slides-visibility
        class="flex-1 w-full h-full"
      >
        <swiper-slide v-for="image in gallery.images" :key="image.name" class="flex items-center justify-center">
          <a :href="`gallery/${gallery.id}/${image.name}`" :data-width="image.width" :data-height="image.height" class="block gallery-item">
            <img
              :src="`gallery/${gallery.id}/previews/${image.name}`"
              class="object-cover w-32 h-64 rounded-sm shadow-2xl xl:w-48 xl:h-96 2xl:w-64 2xl:h-128"
            >
          </a>
        </swiper-slide>
      </swiper>
    </v-photo-swipe>

    <div>
      <page-links>
        <router-link
          v-for="link in collections"
          :key="link.id"
          :to="{ name: 'GalleryId', params: { id: link.id } }"
          active-class="text-escent"
        >
          {{ link.name }}
        </router-link>
      </page-links>
    </div>
  </div>
</template>

<script>
import anime from 'animejs'
import SwiperCore, { Pagination, Scrollbar } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'

import PageLinks from '@/components/PageLinks.vue'

SwiperCore.use([
  Pagination,
  Scrollbar,
])

export default {
  name: 'Gallery',
  components: {
    Swiper,
    SwiperSlide,
    PageLinks,
  },
  props: {
    id: {
      type: String,
      required: false,
      default: 'exterior',
    },
  },
  data () {
    return {
      collections: [
        {
          id: 'exterior',
          name: 'Exterior',
          images: [
            { name: 'MAIN_GATE_FINAL.jpg', width: 3840, height: 2135 },
            { name: 'GARDEN_21st_FLOOR_FINAL.jpg', width: 3840, height: 2135 },
            { name: 'POOL_FINAL2.jpg', width: 3840, height: 1427 },
            { name: 'ROOF_TOP_BUILDING_FINAL.jpg', width: 3840, height: 2467 },
            { name: 'BIRD_EYE_VIEW_FINAL.jpg', width: 3840, height: 2191 },
          ],
        },
        {
          id: 'facilities',
          name: 'Facilities',
          images: [
            { name: '01 LOBBY.jpg', width: 2200, height: 1445 },
            { name: '02 MULTI PURPOSE.jpg', width: 2200, height: 1445 },
            { name: '03 MAIL ROOM.jpg', width: 2200, height: 1445 },
            { name: '04 WC2.jpg', width: 2200, height: 1445 },
            { name: '05 LAUNDRY.jpg', width: 2200, height: 1445 },
            { name: '06 LIFT HALL L1.jpg', width: 2200, height: 1445 },
            { name: '07 LIFT HALL1 L1.jpg', width: 2200, height: 1445 },
            { name: '08 LIFT HALL L22.jpg', width: 2200, height: 1445 },
            { name: '09 WC4-1 L22.jpg', width: 2200, height: 1445 },
            { name: '10 WC4-2 L22.jpg', width: 2200, height: 1445 },
            { name: '11 LIFT HALL L23.jpg', width: 2200, height: 1445 },
            { name: '12 SKY LOUNGE1.jpg', width: 2200, height: 1445 },
            { name: '13 SKY LOUNGE2.jpg', width: 2200, height: 1446 },
            { name: '14 SKY LOUNGE3.jpg', width: 2749, height: 722 },
            { name: '15 FITNESS.jpg', width: 1902, height: 729 },
          ],
        },
        {
          id: 'interior',
          name: 'Interior',
          images: [
            { name: '28.jpg', width: 3840, height: 2304 },
            { name: '29.jpg', width: 3840, height: 1920 },
            { name: '32.jpg', width: 3840, height: 1920 },
            { name: '33.jpg', width: 3840, height: 1920 },
            { name: '51.jpg', width: 3840, height: 1920 },
            { name: '58.jpg', width: 3840, height: 1766 },
            { name: '68.jpg', width: 3840, height: 1121 },
          ],
        },
      ],
    }
  },
  computed: {
    gallery () {
      return this.collections.find(gallery => gallery.id === this.id)
    },
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'GalleryId') {
        this.$nextTick(() => {
          anime({
            targets: '.gallery-item > img',
            duration: 2000,
            opacity: [0, 1],
            translateY: [-200, 0],
            delay: anime.stagger(200),
          })
        })
      }
    },

  },
  activated () {
    if (this.$route.name === 'GalleryId') {
      anime({
        targets: '.gallery-item > img',
        duration: 2000,
        opacity: [0, 1],
        translateY: [-200, 0],
        delay: anime.stagger(200),
      })
    }
  },
}
</script>

<style lang="postcss" scoped>
::v-deep(.swiper-container) {
  @apply px-16;

  @screen xl {
    @apply px-24;
  }

  @screen 2xl {
    @apply px-32;
  }

  .swiper-slide:nth-child(odd) {
    & > * {
      @apply transform translate-y-16;
    }
  }

  .swiper-slide:nth-child(even) {
    & > * {
      @apply transform -translate-y-16;
    }
  }
}
</style>
